import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-footer-section',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './footer-section.html',
  styleUrl: './footer-section.scss'
})
export class FooterSection {
  currentYear = new Date().getFullYear();
}
